/**
 * @generated SignedSource<<d72cc6e0b92dab82d268aab6115759bf>>
 * @relayHash 69aa223603a5d885bd73133e04c6ce27
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 69aa223603a5d885bd73133e04c6ce27

import { ConcreteRequest } from 'relay-runtime';
export type PointOfCareType = "EMERGENCY_CALL" | "EXTERNAL_ASSISTANCE" | "GENERAL_PRACTITIONER" | "HOSPITAL_ELECTIVE" | "HOSPITAL_EMERGENCY_ROOM" | "INCOMPLETE_TELECONSULTATION" | "MEDICAL_EMERGENCY_OR_PERMANENCE" | "SPECIALIST" | "TELECARE";
export type de_BetterDocCareProviderSearchStatus = "BETTER_DOC_UNAVAILABLE" | "INVALID_SEARCH_INPUT" | "INVALID_SPECIALTY" | "PROGRESS_NOTE_NOT_FOUND" | "SUCCESS";
export type betterDocCareProviderSearchQuery$variables = {
  city?: string | null;
  effectivePointOfCare: PointOfCareType;
  name?: string | null;
  progressNoteId: string;
  specialtyId?: string | null;
  street?: string | null;
};
export type betterDocCareProviderSearchQuery$data = {
  readonly de_betterDocCareProviderSearch: {
    readonly careProviders: ReadonlyArray<{
      readonly city: string | null;
      readonly countryCode: string | null;
      readonly medhubActivityId: number;
      readonly medicMedhubId: number;
      readonly medicName: string | null;
      readonly postalCode: string | null;
      readonly street: string | null;
      readonly workplaceMedhubId: number;
      readonly workplaceName: string;
    }>;
    readonly status: de_BetterDocCareProviderSearchStatus;
  };
};
export type betterDocCareProviderSearchQuery = {
  response: betterDocCareProviderSearchQuery$data;
  variables: betterDocCareProviderSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "city"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectivePointOfCare"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "progressNoteId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "specialtyId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "street"
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "city",
        "variableName": "city"
      },
      {
        "kind": "Variable",
        "name": "effectivePointOfCare",
        "variableName": "effectivePointOfCare"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "progressNoteId",
        "variableName": "progressNoteId"
      },
      {
        "kind": "Variable",
        "name": "specialtyId",
        "variableName": "specialtyId"
      },
      {
        "kind": "Variable",
        "name": "street",
        "variableName": "street"
      }
    ],
    "concreteType": "de_BetterDocCareProviderSearchResult",
    "kind": "LinkedField",
    "name": "de_betterDocCareProviderSearch",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "de_BetterDocCareProviderSearchItem",
        "kind": "LinkedField",
        "name": "careProviders",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "medhubActivityId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "medicMedhubId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workplaceMedhubId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "medicName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workplaceName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "street",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "postalCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "city",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "countryCode",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "betterDocCareProviderSearchQuery",
    "selections": (v6/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*:: as any*/),
      (v1/*:: as any*/),
      (v4/*:: as any*/),
      (v2/*:: as any*/),
      (v0/*:: as any*/),
      (v5/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "betterDocCareProviderSearchQuery",
    "selections": (v6/*:: as any*/)
  },
  "params": {
    "id": "69aa223603a5d885bd73133e04c6ce27",
    "metadata": {},
    "name": "betterDocCareProviderSearchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4e2e735ca5300e30f4e2957940e40234";

export default node;
